import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../../utils/api";

const Carousel = () => {
  const RestaurantSavedId = JSON.parse(localStorage.getItem("selectedRestaurantId"));
  const [slides, setSlides] = useState([]);
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get(`/restaurant/${RestaurantSavedId}`);
        const results = response?.data?.data || {};
        setSlides(results?.sliderImages || []);
      } catch (error) {
        console.error("Error fetching restaurant data:", error);
      }
    };
    fetchData();
  }, [RestaurantSavedId]);

  // Auto slide
  useEffect(() => {
    if (slides?.length === 0) return;
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides?.length);
    }, 6000);

    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <div className="relative w-full overflow-hidden">
      {/* Carousel Slides */}
      <div
        className="w-full lg:h-[500px] md:h-[400px]  flex transition-transform duration-[1500ms]"
        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
      >
        {slides?.map((imageUrl, index) => (
          <div
            key={index}
            className="w-full flex-shrink-0 relative h-full"
          >
            {/* Image Container */}
            <div className="w-full h-full flex items-center justify-center">
              <img
                src={imageUrl}
                alt={`Slide ${index + 1}`}
                className="w-full h-full md:object-cover object-contain"
              />
            </div>

            {/* Buttons - Top on mobile, bottom on desktop */}
            <div className="md:absolute inset-0 flex flex-col justify-end md:justify-end  items-center text-white p-4 z-10">
              <div className="flex gap-4 md:mb-6 mt-4 md:mt-0 max-w-7xl w-full justify-center px-4">
                <Link to="/menu" className="flex-1 max-w-[154px]">
                  <button className="w-full py-2 text-white md:text-[#AD343E] bg-[#AF313D] md:h-[54px] h-[40px] text-[11.57px] md:text-[18px] md:bg-white rounded-full transition md:hover:bg-gray-100">
                    View Menu
                  </button>
                </Link>
                <Link to="/menu" className="flex-1 max-w-[154px]">
                  <button className="w-full py-2 border-[#AF313D] border-2 md:border-white md:text-white text-[#AF313D]   font-bold rounded-full md:h-[54px] h-[40px] text-[11.57px] md:text-[18px] md:hover:bg-white hover:text-black transition">
                    Order Now
                  </button>
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Indicators - Hidden on mobile, visible on desktop */}
      <div className="absolute md:bottom-4 bottom-1 left-1/2 transform -translate-x-1/2  items-center space-x-2 md:flex hidden">
        {slides?.map((_, index) => (
          <button
            key={index}
            className={`cursor-pointer transition-all duration-300 ${
              index === currentSlide
                ? "w-16 h-2 bg-[#AD343E] rounded-full"
                : "w-3 h-3 bg-[#737373] rounded-full hover:bg-gray-400"
            }`}
            onClick={() => setCurrentSlide(index)}
            aria-label={`Go to slide ${index + 1}`}
          ></button>
        ))}
      </div>
    </div>
  );
};

export default Carousel;